'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectLandTableDirective from "./directive/projectLandTable";

export default angular.module('investmentProject.project.land', [])
    .directive('projectLandTable', ProjectLandTableDirective)
    .name;